import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { VoltaSweetAlertService } from '@shared/services/volta-sweet-alert/volta-sweet-alert.service';

interface PromiseAlert {
    id:string;
    promise:Promise<any>;
    message:string;
}

interface ErrorAlert {
    id:string;
    error:any;
}

@Injectable({
    providedIn: 'root',
})
export class LoadingAlertService {

    private swalService = inject(VoltaSweetAlertService);

    private _promises = signal<PromiseAlert[]>([]);
    private promises$ = toObservable<PromiseAlert[]>(this._promises);

    private _errors = signal<ErrorAlert[]>([]);

    constructor(){

        this.promises$.subscribe({
            next: (promises) => {
                if(promises.length > 0){
                    const promise = promises.at(0);
                    this.swalService.fireLoading({message: promise?.message});
                }
                else{
                    if(this._errors().length > 0){
                        const error = this._errors().at(-1);
                        this.swalService.fireError(error?.error);
                        this._errors.set([]);
                    }
                    else{
                        this.swalService.close();
                    }
                }
            }
        })

    }

    addPromise(promise:Promise<any>, message:string = "Loading, please wait.", destroyRef:DestroyRef){

        const GUID = crypto.randomUUID();

        const modifiedPromise = promise
        .catch((error) => {
            this.addError(GUID, error, destroyRef);
        })
        .finally(() => {
            this.removePromise(GUID);
        })

        this._promises.update((promises) => [...promises, {
            id: GUID,
            promise: modifiedPromise,
            message: message
        }])

        destroyRef.onDestroy(() => {
            this.removePromise(GUID);
        })

    }

    private addError(GUID:string, error:any, destroyRef:DestroyRef){
        this._errors.update((errors) => [...errors, {
            id: GUID,
            error: error
        }]);

        destroyRef.onDestroy(() => {
            this.removeError(GUID);
        })
    }

    private removePromise(GUID:string){
        if(this._promises().some((promise) => promise.id == GUID)){
            this._promises.update((promises) => [...promises.filter((promise) => promise.id != GUID)])
        }
    }

    private removeError(GUID:string){
        if(this._errors().some((errors) => errors.id == GUID)){
            this._errors.update((errors) => [...errors.filter((error) => error.id != GUID)])
        }
    }
  
}
